// Copyright (c) 2024 Comsearch, Inc., All rights reserved

import { valueMustBeWithinMaxLength } from 'validators/common'

export const validateAreaOfOperation = (value, error) => {
  if (value) {
    error.areaOfOperation = valueMustBeWithinMaxLength(value, 200)
  }
}

